import { useEffect, useRef } from 'react';
import news from "../../images/events/events.jpg";
import gsap from 'gsap';

export default function EventsIntro() {
  const sectionRef = useRef(null);

  useEffect(() => {
    if (sectionRef.current) {
      gsap.fromTo(sectionRef.current,
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out' }
      );
    }
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full h-[100vh] h-[100dvh] flex items-start justify-center overflow-hidden pt-32 md:pt-48">
      <div
        className="absolute inset-0 z-0 bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url(${news})`,
          /* MOBILE: '15% center' - This pulls the image left. 
             If you want it EVEN MORE to the left, try '0%' or 'left'.
             DESKTOP: 'center' or '25%'
          */
          backgroundPosition: window.innerWidth < 768 ? '90% left' : '25% center',
        }}
      >
        <div className="absolute inset-0 bg-black/20 md:bg-transparent" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center px-4">
        <h2 className="font-custom font-bold text-white md:text-8xl text-5xl tracking-tight">
          EVENTS
        </h2>
      </div>
    </section>
  );
}